import { useGetOptions } from '~map-settings/hooks/useGetOptions'
import { MapFieldSettingDetail as View } from 'ui-components'
import { useCurrentProperty, useSetCurrentProperty } from '~map-settings/states'

import { useMap } from '~map-preview/states/map'
import { useUpdateMapSettings } from '~map-settings/query/useUpdateMapSettings'

export const MapFieldSetting = () => {
  const currentProperty = useCurrentProperty() as any
  const options = useGetOptions(currentProperty)
  const map = useMap()
  const { properties: items } = map
  const updateMapSettings = useUpdateMapSettings()

  const setCurrentProperty = useSetCurrentProperty()

  const handlePropertyChange = async (property: any) => {
    setCurrentProperty(property)

    if (!items?.length) return

    const newProperties = items?.map((item) => {
      if (item.name === property.name) return property

      return item
    })

    await updateMapSettings(newProperties)
  }

  return (
    <View
      property={currentProperty}
      options={options}
      onChange={handlePropertyChange}
    />
  )
}
